<template lang="pug">
v-dialog(v-model="value" max-width="90%" persistent scrollable)
  v-card.dialog
    v-card-title
      span.text-h6 Комментарии
      v-spacer
      v-btn(icon @click="$emit('input', false)")
        v-icon mdi-close

    v-divider
    v-card-text.messages(ref="messages")
      v-row.mb-4(
        v-for="msg in sortedMessages"
        :key="msg.id"
        :justify="msg.user.type.title === 'CUSTOMER' ? 'start' : 'end'"
      )
        v-col(cols="7")
          v-card.message(flat)

            div.reply-preview(v-if="msg.parentId")
              span {{ getMessageText(msg.parentId) }}

            div.message-text
              div.message-body {{ msg.messageBody }}
              div.ml-auto.text-caption {{ dateFormat(msg.createDate) }}

              div.message-buttons.ml-6
                v-btn( v-if="msg.user.type.title == 'CUSTOMER' && isCoordinator" rounded small @click="checkMessage(msg)" )
                  v-icon(:color="msg.read ? '#28FF30' : '#FF000033'") mdi-check-circle-outline

                v-btn.ml-3(
                  rounded
                  small
                  @click="setReply(msg)"
                )
                  v-icon.rotate-90 mdi-redo-variant

    v-card.reply-box.ml-3(v-if="replyTo")
      v-row(no-gutters align="center")
        v-col
          div.text-caption.purple-text В ответ:
          div.text-body-2 {{ replyTo.messageBody }}
        v-col(cols="auto")
          v-btn.close-reply(icon small @click="replyTo = null")
            v-icon(color="#6200EA") mdi-close-circle-outline

    v-card-actions.input-box(v-if="isCustomer || isCoordinator")
      v-text-field(
        v-model="newMessage"
        dense
        outlined
        hide-details
        placeholder="Написать ответ"
        @keyup.enter="sendMessage"
      )
      v-btn.ml-2(
        color="primary"
        :disabled="!newMessage"
        @click="sendMessage"
      ) Отправить
</template>

<script>
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex'

export default {
  name: 'CommentsDialog',

  props: {
    value: {
      type: Boolean,
      required: true
    }
  },

  data () {
    return {
      newMessage: '',
      replyTo: null
    }
  },

  computed: {
    ...mapState('dialogMessage', ['dialogMessages']),
    ...mapGetters('authentication', ['checkRole']),

    sortedMessages () {
      return [...this.dialogMessages].sort(
        (a, b) => new Date(a.createDate) - new Date(b.createDate)
      )
    },

    isCustomer() {
      return this.checkRole(0)
    },

    isCoordinator() {
      return this.checkRole(2)
    },
  },

  mounted() {
    this.scrollToBottom()
  },

  watch: {
    value (val) {
      if (val) this.$nextTick(this.scrollToBottom)
    }
  },

  methods: {
    ...mapActions('dialogMessage', ['readMessage', 'checkUnreadMessage']),
    ...mapMutations('dialogMessage', ['setReadToMessage']),

    setReply(msg) {
      this.replyTo = msg
      this.$nextTick(this.scrollToBottom)
    },

    checkMessage(msg) {
      this.readMessage(msg.id).then(() => {
        this.setReadToMessage(msg.id)
        this.checkUnreadMessage()
        window.alert('Комментарий прочитан')
      })
    },

    sendMessage () {
      if (!this.newMessage) return

      this.$emit('send',this.newMessage, this.replyTo ? this.replyTo.id : null)

      this.newMessage = ''
      this.replyTo = null
      this.$nextTick(this.scrollToBottom)
    },

    getMessageText (id) {
      const msg = this.dialogMessages.find(m => m.id === id)
      return msg ? msg.messageBody : ''
    },

    scrollToBottom () {
      const el = this.$refs.messages
      if (el) el.scrollTop = el.scrollHeight
    },

    dateFormat(date) {
      const d = new Date(date)
      return `${String(d.getDate()).padStart(2, '0')}.${String(
        d.getMonth() + 1
      ).padStart(2, '0')}.${d.getFullYear()}`
    }
  }
}
</script>

<style scoped>
.dialog {
  height: 80vh;
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
}
.messages {
  height: 100%;
  overflow-y: auto;
}

.message {
  border-radius: 10px;
  border: 1px solid #0000001F;
  padding-bottom: 8px;
}

.reply-preview {
  font-size: 13px;
  background: #6200EA1A;
  padding: 6px 10px;
  margin: 6px;
  border-left: 3px solid #6200ea;
  border-radius: 6px;
}

.purple-text {
  font-weight: bold;
  color: #6200EA;
}

.message-text {
  display: flex;
  align-items: center;
  padding: 12px 16px;
}

.reply-box {
  margin-top: 4px;
  padding: 11px;
  border-left: 2px solid #6200EA;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
  border-top-width: 1px;
  border-top: 1px solid #0000001F;
  flex-shrink: 0;
}

.message-body {
  white-space: pre-wrap;
}

.close-reply {
  margin-right: 30px;
}

.rotate-90 {
  transform: rotate(180deg);
}
.message-buttons {
  display: flex;
}
</style>
